import React from "react";
import "./../../UaeAttestation/UaeReq/UaeReq.css";

const OmanReqMain = () => {
  return (
    <div className="uaeReqMainContainer">
      <div className="uaeReqMainContent">
        <h3>Requirement of apostille for Oman:</h3>
        <p>
          Authentication for Oman has its own necessity in the visa process &
          growth of the business in Oman. Apostille is required as it is among
          the countries that are a part of the Hague Convention which is also
          known as the Apostille Convention.
        </p>
        <p>
          There are some policies of Oman that need documents with MEA sticker
          to permit a visitor to stay or perform business in their nation. It is
          a part of security in order to prove the authenticity of the
          documents. Therefore, the validation of documents becomes important
          for these reasons.
        </p>
      </div>
      <div className="uaeReqMainContent">
        <h3>Total time to get Document Apostille:</h3>
        <p>
          The total time period needed for Apostille for Oman depends on various
          aspects such as which state the certificate was issued from, or the
          sort of documents, or the authority you need it from. Generally, it
          will take around 2-3 working days to accomplish the whole process of
          Oman Apostille services in Bangalore.
        </p>
      </div>
    </div>
  );
};

export default OmanReqMain;
